import { DirectionalLightProps } from '@react-three/fiber'
import { DirectionalLight as DirectionalLightThree, Object3D, Vector3 } from 'three'
import DebugDirectionalLight from '../../f.assets/scripts/DebugDirectionalLight'
import DebugDirectionalLightCamera from '../../f.assets/scripts/DebugDirectionalLightCamera'
import { useScripts } from '../../f.assets/scripts/useScripts'
import { getParentScene } from '../../utils/threejs'
import GameElements from '../GameElements/GameElement/GameElement'

const adjustLightCamera = (obj: Object3D) => {
  const scene = getParentScene(obj)
  const light = obj.children[0] as DirectionalLightThree
  light.shadow.camera.near = 0
  light.shadow.camera.far = 16
  light.shadow.camera.scale.set(2, 2, 2)
  light.target = new Object3D()
  light.target.position.set(0, 0, 0)

  scene?.add(light.target)
}

const DirectionalLight = ({
  debug,
  debugCamera,
  ...props
}: {
  debug?: boolean
  debugCamera?: boolean
} & DirectionalLightProps) => {
  const scripts = [adjustLightCamera]

  if (debugCamera) {
    scripts.push(DebugDirectionalLightCamera())
  }
  if (debug) {
    scripts.push(DebugDirectionalLight())
  }

  return (
    <GameElements onStart={useScripts(scripts)}>
      <directionalLight {...props} />
    </GameElements>
  )
}
export default DirectionalLight
